import { GenericBackendResponse } from '../genericBackendResponse';

export interface ReinviteEmployeeResult {
	invitationToken: string;
	invitationLink: string;
	emailSent: boolean;
}

/**
 * Re-invita a un empleado existente (pending o declined) de una empresa.
 * Endpoint company-scoped: el backend valida que el admin está relacionado con
 * la empresa y que el empleado le pertenece. Para un declined revierte el
 * rechazo del plan y lo re-incorpora. Solo necesita el userId del empleado.
 */
const reinviteEmployee = async (
	token: string,
	companyId: string,
	userId: string,
	sendEmail = true
): Promise<GenericBackendResponse<ReinviteEmployeeResult>> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/companies/${companyId}/reinvite-employee`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify({ userId, sendEmail })
		}
	);

	if (!response.ok) {
		throw new Error('Network response was not ok');
	}

	return response.json();
};

export default reinviteEmployee;
